import { useEffect, useState } from 'react'
import { X, Trophy, Star, CheckCircle } from 'lucide-react'
import Confetti from './Confetti'
import Button from './Button'

interface ModalParabensProps {
    isOpen: boolean
    onClose: () => void
    cursoTitulo: string
    progresso: number
}

export default function ModalParabens({ isOpen, onClose, cursoTitulo, progresso }: ModalParabensProps) {
    const [showConfetti, setShowConfetti] = useState(false)

    useEffect(() => {
        if (isOpen && progresso >= 100) {
            setShowConfetti(true)
            // Parar confetes após 3 segundos
            const timer = setTimeout(() => {
                setShowConfetti(false)
            }, 3000)
            return () => clearTimeout(timer)
        }
    }, [isOpen, progresso])

    if (!isOpen || progresso < 100) return null

    return (
        <>
            <Confetti isActive={showConfetti} duration={3000} />

            <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
                <div className="bg-white dark:bg-gray-800 rounded-2xl shadow-2xl max-w-md w-full mx-4 overflow-hidden">
                    {/* Header com gradiente */}
                    <div className="bg-gradient-to-r from-yellow-400 via-yellow-500 to-yellow-600 p-6 text-center relative">
                        <button
                            onClick={onClose}
                            className="absolute top-4 right-4 text-white hover:text-yellow-200 transition-colors"
                        >
                            <X size={24} />
                        </button>

                        <div className="flex justify-center mb-4">
                            <div className="bg-white bg-opacity-20 rounded-full p-4">
                                <Trophy className="h-16 w-16 text-white" />
                            </div>
                        </div>

                        <h2 className="text-2xl font-bold text-white mb-2">
                            🎉 Parabéns! 🎉
                        </h2>
                        <p className="text-white text-lg font-medium">
                            Você concluiu com sucesso este curso!
                        </p>
                    </div>

                    {/* Conteúdo */}
                    <div className="p-6 text-center">
                        <div className="mb-6">
                            <h3 className="text-xl font-semibold text-gray-900 dark:text-gray-100 mb-2">
                                {cursoTitulo}
                            </h3>
                            <div className="flex items-center justify-center gap-2 text-green-600 dark:text-green-400 mb-4">
                                <CheckCircle className="h-6 w-6" />
                                <span className="font-medium">100% Concluído</span>
                            </div>
                        </div>

                        {/* Estrelas */}
                        <div className="flex justify-center gap-2 mb-6">
                            {[1, 2, 3, 4, 5].map((star) => (
                                <Star key={star} className="h-8 w-8 text-yellow-400 fill-current" />
                            ))}
                        </div>

                        {/* Mensagem motivacional */}
                        <div className="bg-gradient-to-r from-green-50 to-blue-50 dark:from-green-900/20 dark:to-blue-900/20 rounded-lg p-4 mb-6">
                            <p className="text-gray-700 dark:text-gray-300 font-medium">
                                Sua dedicação e esforço foram recompensados!
                                Continue assim e alcance novos objetivos.
                            </p>
                        </div>

                        {/* Botões */}
                        <div className="flex gap-3 justify-center">
                            <Button
                                variant="btn_secondary"
                                onClick={onClose}
                                className="px-6"
                            >
                                Continuar Aprendendo
                            </Button>
                            <Button
                                variant="btn_add"
                                onClick={() => {
                                    // Aqui você pode adicionar funcionalidade para compartilhar conquista
                                    console.log('Compartilhar conquista')
                                }}
                                className="px-6"
                            >
                                Compartilhar Conquista
                            </Button>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}


